import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authorize, clearUser, setUser } from "../redux/ducks/user";
import { ReducersTypes } from "../redux/reducers/Models";
import IndexView from "./view";
import { setCustomer } from "@/redux/ducks/customer";
import useQuery from "@/hooks/useQuery";
import useCaptcha from "@/hooks/useCaptcha";

export default function Index() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useQuery();
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const location = useLocation();

  const [isVisibleMenu, setIsVisibleMenu] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isVisibleModalLogin, setIsVisibleModalLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAcceptedTerms, setIsAcceptedTerms] = useState(false);
  const [isAcceptedPrivacy, setIsAcceptedPrivacy] = useState(false);
  const [error, setError] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  const captchaName = "mtcaptcha";
  useCaptcha({ captchaName, setIsVerified });

  useEffect(() => {
    // @ts-expect-error
    if (window?.mtcaptcha?.getStatus(captchaName)?.isVerified) {
      setIsVerified(true);
    }
  }, [location.pathname]);

  const toggleMenu = () => setIsVisibleMenu(isVisibleMenu => !isVisibleMenu);
  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);
  const toggleModalLogin = () => setIsVisibleModalLogin(isVisibleModalLogin => !isVisibleModalLogin);
  const toggleTerms = () => setIsAcceptedTerms(isAcceptedTerms => !isAcceptedTerms);
  const togglePrivacy = () => setIsAcceptedPrivacy(isAcceptedPrivacy => !isAcceptedPrivacy);

  const goToCreateAccount = () => navigate("/register");

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(setUser({ [name]: value }));
  }

  const getIsValidForm = () => {
    return (user?.plate as string)?.length === 8 && isAcceptedTerms && isAcceptedPrivacy;
  };

  const handleAuthorize = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage === "timeout") setError(true);
      toggleModal();
      // @ts-expect-error
      window?.mtcaptcha?.resetUI(captchaName);
      return;
    }

    navigate("/home");
  }

  const goToDebts = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!getIsValidForm() || isLoading) return;

    setIsLoading(true);

    dispatch(
      authorize({
        plate: user?.plate as string,
        // @ts-expect-error
        token: window?.mtcaptcha?.getVerifiedToken?.(captchaName),
        callback: handleAuthorize,
      })
    );
  }

  useLayoutEffect(() => {
    dispatch(setUser({ plate: '' }));
    dispatch(setCustomer({
      register: undefined,
      forgot: undefined,
      customer: undefined,
      products: undefined,
      client: undefined,
      vehicles: undefined,
      extract: undefined,
      recharges: undefined,
      isLoadingVehicles: false,
      tickets: undefined,
      debts: undefined,
    }));
    dispatch(clearUser());
    if (params.get("auth")) {
      toggleModalLogin();
    }
  }, []);

  return (
    <IndexView
      toggleMenu={toggleMenu}
      isVisibleMenu={isVisibleMenu}
      user={user}
      onChange={onChange}
      goToDebts={goToDebts}
      isDisabled={!getIsValidForm()}
      isLoading={isLoading}
      error={error}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      isAcceptedTerms={isAcceptedTerms}
      isAcceptedPrivacy={isAcceptedPrivacy}
      toggleTerms={toggleTerms}
      togglePrivacy={togglePrivacy}
      isVisibleModalLogin={isVisibleModalLogin}
      toggleModalLogin={toggleModalLogin}
      goToCreateAccount={goToCreateAccount}
    />
  );
}
